import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-input-number",
  styleUrls: ["./view-input-number.component.scss"],
  templateUrl: "./view-input-number.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ViewInputNumberComponent),
      multi: true,
    },
  ],
})
export class ViewInputNumberComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private alive = true;
  private destroy$: Subject<void> = new Subject<void>();
  @Output() valueChange = new EventEmitter<any>();
  @Input() mode?: string;

  @Input() position?: string = "top"; //top/left/right/bottom
  @Input() status?: string = "primary"; //primary/danger/info/success/warning
  @Input() placeholder?: string = "";
  @Input() inValue: number;

  @ViewChild("elValue") elValue: ElementRef;

  renderCss: string = "text-primary";
  renderValue: number = 0;
  inputValue: string = "";
  inputPrice: boolean = true;

  constructor() {}

  ngOnInit(): void {
    this.renderCss = "text-" + this.status;
    this.renderValue = isNaN(this.inValue) ? 0 : this.inValue;
    this.inputValue = this.renderValue === 0 ? "" : this.renderValue.toString();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.elValue.nativeElement.focus();
      this.inputPrice = false;
    }, 1000);
  }

  //custom event input
  openInputPrice() {
    this.inputPrice = true;
    this.inputValue = this.renderValue === 0 ? "" : this.renderValue.toString();

    console.log("openInputPrice/elValue:", this.elValue);

    this.elValue.nativeElement.focus();
  }

  closeInputPrice() {
    this.inputPrice = false;
    this.renderValue = isNaN(this.inValue) ? 0 : this.inValue;
    this.inputValue = this.renderValue === 0 ? "" : this.renderValue.toString();
  }

  onChange() {
    this.renderValue = isNaN(parseFloat(this.inputValue))
      ? this.inValue
      : parseFloat(this.inputValue);
  }

  onEnter() {
    this.inputPrice = false;

    this.renderValue = isNaN(parseFloat(this.inputValue))
      ? this.inValue
      : parseFloat(this.inputValue);
    this.inValue = this.renderValue;
    this.valueChange.emit(this.inValue);
  }
}
